import { render, staticRenderFns } from "./payableDetail.vue?vue&type=template&id=f80f608e&scoped=true"
import script from "./payableDetail.vue?vue&type=script&lang=js"
export * from "./payableDetail.vue?vue&type=script&lang=js"
import style0 from "./payableDetail.vue?vue&type=style&index=0&id=f80f608e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f80f608e",
  null
  
)

export default component.exports